import { CircularProgress, DialogActions, Typography } from '@mui/material'
import { Button } from '@/@core/components/mui/Button'
import { useTranslator } from '@/hooks'
import Link from '@components/Link'

interface SignUpFormStepActionProps {
  handleBack: () => void
  handleNext: () => void
  handleSubmit?: () => void
  steps: Array<{ labelPC: string; labelMB: string }>
  activeStep: number
  handleClose: () => void
  loadingForm: boolean
  isStepValid: boolean
}

export default function SignUpFormStepAction({
  handleBack,
  handleNext,
  activeStep,
  loadingForm,
  isStepValid
}: SignUpFormStepActionProps) {
  const { __ } = useTranslator()

  return (
    <DialogActions
      classes={{
        root: [1, 3].includes(activeStep)
          ? 'flex flex-col items-center justify-between px-0 gap-6'
          : activeStep === 2
            ? 'flex flex-col items-center justify-between px-0 gap-6'
            : 'flex flex-col items-center justify-between px-0 gap-6'
      }}
    >
      {activeStep === 0 && (
        <>
          <Button
            variant='contained'
            onClick={handleNext}
            className='gap-2 rounded-full w-full py-[15px]'
            sx={{
              height: 48
            }}
          >
            <div className='text-[#fff] text-[17px] font-semibold flex items-center'>
              {activeStep === 0 && <span>{__('Confirm Information')}</span>}
            </div>
          </Button>
          <Typography className='text-[15px]'>
            {__(' Found wrong info? ')}
            <Link href='https://zalo.me/0989646482' className='text-[15px] text-[#3551F2] font-semibold'>
              {__('Contact Us!')}
            </Link>
          </Typography>
        </>
      )}

      {activeStep === 1 && (
        <Button
          type='button'
          variant='contained'
          className='gap-2 rounded-full w-full py-[15px]'
          onClick={handleNext}
          disabled={!isStepValid || loadingForm}
          sx={{
            height: 48
          }}
        >
          <div className='text-[#fff] text-[17px] font-semibold flex items-center gap-2'>
            {__('Set password')}
            {loadingForm && <CircularProgress color='info' className='ml-2' size={20} />}
          </div>
        </Button>
      )}

      {activeStep === 2 && (
        <Button
          type='button'
          variant='contained'
          className='gap-2 rounded-full w-full py-[15px]'
          color={'success'}
          disabled={true}
          sx={{
            height: 48
          }}
        >
          <div className='text-[#fff] text-[17px] font-semibold flex items-center gap-2'>
            {__('Waiting to login to the system')}
            {<CircularProgress className='ml-2 text-white' size={20} />}
          </div>
        </Button>
      )}

      {activeStep > 0 && activeStep < 2 && (
        <Button
          variant='contained'
          className='bg-[#6F83F629] text-[#6F83F6] text-[15px] gap-2 rounded-full w-full py-[15px] ml-0'
          startIcon={<i className='tabler-arrow-left' />}
          onClick={handleBack}
          sx={{
            height: 48,
            '&.MuiButtonBase-root ': {
              boxShadow: 'none'
            }
          }}
        >
          {__('Previous')}
        </Button>
      )}
    </DialogActions>
  )
}
